<template>
  <div v-if="items">
    <ul class="label-m font-bold mt-5 grid gap-2">
      <li v-for="item in items" :key="item.target">
        <NuxtLink
          :to="`#${item.target}`"
          :class="{ 'text-gray-500': `#${item.target}` !== route.hash }"
          >{{ item.title }}</NuxtLink
        >
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  items: {
    title: string
    target: string
  }[]
}>()

const route = useRoute()
</script>
